export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '8b5bef8', dateTime: 1784298724042 };